export const AboutMe = {
  id: 'about',
  imgStart: true,
  img: require('../../images/sean.jpg'),
  alt: 'Headshot',
};
